import {createApp} from "vue";
import {createPinia} from "pinia";
import UIkit from "uikit";
import CartButton from "./components/CartButton.vue";
import CartAmountButton from "./components/CartAmountButton.vue";
import CartMenuIcon from "./components/CartMenuIcon.vue";
import SearchAutocompleteDesktop from "./components/SearchAutocompleteDesktop.vue";
import SearchAutocompleteMobile from "./components/SearchAutocompleteMobile.vue";
import FormOrder from "./components/FormOrder.vue";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import DealerSearch from "./components/DealerSearch.vue"
import DeliveryAddressManagement from "./components/DeliveryAddressManagement.vue";
import i18n from "./service/translation.js"
import TempDeliveryAddressHandler from "./components/TempDeliveryAddressHandler.vue";
import PriceHide from "./components/PriceHide.vue";

const pinia = createPinia()

const cId = ((id) => {
    return document.getElementById(id)
})

if(cId('searchAutocompleteDesktop')) {
    createApp(SearchAutocompleteDesktop).mount('#searchAutocompleteDesktop');
}

if(cId('searchAutocompleteMobile')) {
    createApp(SearchAutocompleteMobile).mount('#searchAutocompleteMobile');
}

const searchOverlayMobile = cId('ws-search-overlay-mobile');
if(searchOverlayMobile) {
    // Focus must happen synchronously within the toggle's click handling (beforeshow,
    // not shown) so iOS Safari still counts it as a user gesture and opens the keyboard.
    UIkit.util.on(searchOverlayMobile, 'beforeshow', () => {
        const input = searchOverlayMobile.querySelector('.uk-search-input');
        if (input) {
            input.focus();
        }
    });
}

if(cId('ws-form-order')) {
    createApp(FormOrder).use(i18n).mount('#ws-form-order');
}

if(cId('ws-price-hide-app')) {
    let ElementPriceHideApp = cId('ws-price-hide-app')
    let tempPriceHideApp = createApp(PriceHide);
    tempPriceHideApp.config.globalProperties.hvpShowState = ElementPriceHideApp.getAttribute('data-show-state')
    tempPriceHideApp.use(i18n).use(pinia).mount('#ws-price-hide-app');
}

if(cId('deliveryAddressManagement')) {
    createApp(DeliveryAddressManagement).use(i18n).use(pinia).mount('#deliveryAddressManagement');
}

let ElementDeliveryManagement = cId('form-address-select')
if(cId('form-address-select')) {
    let tempDelApp = createApp(TempDeliveryAddressHandler);
    tempDelApp.config.globalProperties.tempSelected = ElementDeliveryManagement.getAttribute('data-temp-deliveryaddress')
    tempDelApp.use(i18n).use(pinia).mount('#form-address-select');
}


const ElementListCartButtons = [...document.querySelectorAll('.ws-app-cart-button')];
ElementListCartButtons.forEach(ElementCartButton => {
    let tmpApp = createApp(CartButton);
    tmpApp.config.globalProperties.pid = ElementCartButton.getAttribute('data-pid');
    tmpApp.use(pinia);
    tmpApp.mount(ElementCartButton);
});

const ElementListCartAmountButtons = [...document.querySelectorAll('.ws-app-cart-item-amount')];
ElementListCartAmountButtons.forEach(ElementCartAmountButton => {

    let tmpApp = createApp(CartAmountButton);
    tmpApp.config.globalProperties.dataItemId = ElementCartAmountButton.getAttribute('data-item');
    tmpApp.config.globalProperties.dataItemCount = ElementCartAmountButton.getAttribute('data-count');
    tmpApp.use(pinia);
    tmpApp.mount(ElementCartAmountButton);
});

const MenuCartIconList = [...document.querySelectorAll('.ws-cart-menu-icon')];
MenuCartIconList.forEach(MenuCartIcon => {
    let tmpApp = createApp(CartMenuIcon);
    tmpApp.use(pinia);
    tmpApp.mount(MenuCartIcon);
});


if(cId('ws-dealer-search')) {
    createApp(DealerSearch)
        .use(VueGoogleMaps, {
            load: {
                apiKey: 'AIzaSyDYXXJNZMYfsyJx8y9ICJhZwNjuHlH4ONs',
                libraries: 'places'
            }
        })
        .mount('#ws-dealer-search');
}
